:host(.menu-toggle-hidden) {
  display: none;
}